import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { LoggingService, LogLevel } from '@app/services/logging.service';
import { first, interval, concat } from 'rxjs';

@Injectable()
export class PwaCheckUpdateService {
  static readonly COMPONENT_NAME = 'PwaCheckUpdateService';


  constructor(private appRef: ApplicationRef, private updates: SwUpdate, private loggingService: LoggingService) {
  }

  public init() {
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const everySixMins$ = interval(6 * 60 * 1000);
    const everySixMinsOnceAppIsStable$ = concat(appIsStable$, everySixMins$);

    everySixMinsOnceAppIsStable$.subscribe(async () => {
      try {
        const updateFound = await this.updates.checkForUpdate();
        this.loggingService.log(LogLevel.DEBUG, PwaCheckUpdateService.COMPONENT_NAME, updateFound ? '[PWA]: A new version is available.' : '[PWA]: Already on the latest version.');
      } catch (err) {
        this.loggingService.log(LogLevel.ERROR, PwaCheckUpdateService.COMPONENT_NAME, '[PWA]: Failed to check for updates:' , err);
      }
    });

    this.loggingService.log(LogLevel.DEBUG, PwaCheckUpdateService.COMPONENT_NAME, `[PWA]: Initialized PwaCheckUpdateService`);

  }

}
